import { useCallback } from 'react';

import { ApiNotification } from 'api/notification/types/ApiNotification';
import { NotificationList } from 'components/NotificationList/NotificationList';
import { markNotificationsAsViewed } from 'modules/main/store/ducks/userNotifications.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { MappedNotification } from 'types/mappedNotifications/MappedNotification';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEvent } from 'utils/analytics/track/trackEvent';
import { getMappedNotificationIds } from 'utils/userNotifications';

import { StaffNotificationsIcon } from './StaffNotificationsIcon';
import { StaffPageHeaderDropdownMenu } from './StaffPageHeaderDropdownMenu';

export function StaffPageHeaderNotificationsDropdown() {
  const dispatch = useMainDispatch();

  const { notifications } = useMainSelector((state) => state.userNotifications);

  const handleView = useCallback(
    (viewedNotifications: (ApiNotification | MappedNotification)[]) =>
      dispatch(
        markNotificationsAsViewed(
          viewedNotifications.flatMap((notification) =>
            getMappedNotificationIds(notification),
          ),
        ),
      ),
    [dispatch],
  );

  return (
    <StaffPageHeaderDropdownMenu
      right
      aria-label={getText('Notifications')}
      title={
        <StaffNotificationsIcon notifications={notifications} id="desktop" />
      }
      height="370px"
      width={260}
      data-qa-id="notifications-dropdown"
      onClick={(open) => {
        trackClicked('Header Utility CTA - Notifications');

        if (open && notifications.length) {
          handleView(notifications);

          trackEvent('Displayed User Menu Notifications', {
            notification_types: notifications.reduce(
              (acc, notification) =>
                // @ts-expect-error TS(2769): No overload matches this call.
                acc.includes(notification.type)
                  ? acc
                  : [...acc, notification.type],
              [],
            ),
          });
        }
      }}
    >
      {({ closeMenu }) => (
        <NotificationList
          notifications={notifications}
          dismissible
          onClick={closeMenu}
        />
      )}
    </StaffPageHeaderDropdownMenu>
  );
}
